import { useCurrencies } from "hooks/useCurrencies.ts";
import React from "react";
import { CurrencyCode, formatCurrency } from "utils/formatCurrency.ts";

import CommissionData = App.Data.CommissionData;

interface CurrencyCellProps {
    commission: CommissionData;
    fallback?: React.ReactNode;
}

export const PayoutCell: React.FC<CurrencyCellProps> = ({ commission, fallback = "-" }) => {
    const { loading, error, get } = useCurrencies();
    
    const currency = get(commission.offer?.currency_id)

    if (loading || error) {
        return null
    }
    
    if (commission.payout_placeholder) {
        return <>{commission.payout_placeholder}</>;
    }

    if (commission.payout_formula && commission.formula_type === 'percent') {
        return <>{commission.payout_formula}%</>
    }

    if (commission.payout_formula && commission.formula_type === 'fix' && currency) {
        return (
            <>
                {formatCurrency(Number(commission.payout_formula), currency.currency_code as CurrencyCode)}
            </>
        );
    }

    if (commission.payout_formula && commission.formula_type === 'formula') {
        return <>{commission.payout_formula}</>;
    }

    return <>{fallback}</>;
};
